export default "__VITE_ASSET__CB$4DC79__"